export const viewTitle = "Хранилище данных ЦХЭД";
export const viewUniqKey = "filestorage";
